/**
 * 一张长图按视口高度要滚几屏。
 *
 * 「8.3 屏」这种盲滚感必须说出来 —— 用户在 504px 的窗口里读 4161px 的图,
 * 不告诉他总共多长,他不知道自己读到哪了。
 */
export function screenCount(imgHeight: number, viewportHeight: number, renderScale = 1): number {
  if (imgHeight <= 0 || viewportHeight <= 0) return 1;
  return Math.max(1, Math.ceil((imgHeight * renderScale) / viewportHeight));
}
